import {
  IPayrollChangeRequestActions,
  IPayrollChangeRequestFetchActionPayload,
  IPayrollChangeRequestStateActionPayload,
  PayrollChangeRequestContext
} from './actions.types';
import { IPayrollChangeRequestData, IUserData } from '@/models';
import { Transition } from '@/models/transition';
import { IPayrollChangeRequestPaginatedListData } from '@/services';

export const actions: IPayrollChangeRequestActions = {
  fetchPayrollChangeRequests(
    context: PayrollChangeRequestContext,
    payload: IPayrollChangeRequestFetchActionPayload
  ): Promise<void> {
    const promise = this.$services.payrollChangeRequest.fetchPayrollChangeRequests(
      payload.page,
      payload.search,
      payload.state,
      payload.self
    );
    context.commit('SET_LAST_PROMISE', promise);
    return promise.then(
      (payrollChangeRequests: IPayrollChangeRequestPaginatedListData) => {
        if (promise == context.state.lastPromise) {
          context.commit(
            'SET_PAYROLL_CHANGE_REQUESTS',
            payrollChangeRequests.results
          );
          context.commit('SET_COUNT', payrollChangeRequests.count);
          context.commit('SET_LAST_PROMISE', null);
        }
      }
    );
  },

  fetchPayrollChangeRequest(
    context: PayrollChangeRequestContext,
    payload: number
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .fetchPayrollChangeRequest(payload)
      .then((payrollChangeRequest: IPayrollChangeRequestData) => {
        const index = context.state.payrollChangeRequests.findIndex(
          (v: IPayrollChangeRequestData) => v.id === payrollChangeRequest.id
        );
        if (index === -1) {
          context.commit('ADD_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
        }
      });
  },

  createPayrollChangeRequest(
    context: PayrollChangeRequestContext,
    payload: IPayrollChangeRequestData
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .createPayrollChangeRequest(payload)
      .then((payrollChangeRequest: IPayrollChangeRequestData) => {
        context.commit('ADD_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
        context.commit('INCREMENT_COUNT');
      });
  },

  updatePayrollChangeRequest(
    context: PayrollChangeRequestContext,
    payload: IPayrollChangeRequestData
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .updatePayrollChangeRequest(payload)
      .then((payrollChangeRequest: IPayrollChangeRequestData) => {
        const index = context.state.payrollChangeRequests.findIndex(
          (v: IPayrollChangeRequestData) => v.id === payrollChangeRequest.id
        );
        if (index === -1) {
          context.commit('ADD_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
        }
      });
  },

  deletePayrollChangeRequest(
    context: PayrollChangeRequestContext,
    payload: number
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .deletePayrollChangeRequest(payload)
      .then(() => {
        context.commit('REMOVE_PAYROLL_CHANGE_REQUEST', payload);
        context.commit('DECREMENT_COUNT');
      });
  },

  updatePayrollChangeRequestState(
    context: PayrollChangeRequestContext,
    payload: IPayrollChangeRequestStateActionPayload
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .updatePayrollChangeRequestState(
        payload.payrollChangeRequestId,
        payload.state,
        payload.assignee
      )
      .then((payrollChangeRequest: IPayrollChangeRequestData) => {
        const index = context.state.payrollChangeRequests.findIndex(
          (v: IPayrollChangeRequestData) => v.id === payrollChangeRequest.id
        );
        if (index === -1) {
          context.commit('ADD_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_PAYROLL_CHANGE_REQUEST', payrollChangeRequest);
        }
      });
  },

  fetchPayrollChangeRequestActivities(
    context: PayrollChangeRequestContext,
    payload: number
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .fetchPayrollChangeRequestActivities(payload)
      .then((activities: Transition[]) => {
        context.commit('SET_PAYROLL_CHANGE_REQUEST_ACTIVITIES', activities);
      });
  },

  fetchPayrollChangeRequestHRPersonnels(
    context: PayrollChangeRequestContext,
    payload: number
  ): Promise<void> {
    return this.$services.payrollChangeRequest
      .fetchPayrollChangeRequestHRPersonnels(payload)
      .then((payrollChangeRequestHRPersonnels: IUserData[]) => {
        context.commit(
          'SET_PAYROLL_CHANGE_REQUEST_HR_PERSONNELS',
          payrollChangeRequestHRPersonnels
        );
      });
  },

  //export
  exportPayrollChangeRequestPdf(
    _context: PayrollChangeRequestContext,
    payload: number
  ): Promise<Blob> {
    return this.$services.payrollChangeRequest.exportPayrollChangeRequestPdf(
      payload
    );
  }
};
